import useFeatureFlags from 'hooks/useFeatureFlags'
import { lazy, Suspense } from 'react'
import AddLogModal from '../../../../components/modals/AddLogModal'
import {
  isStructuredLogsEnabled,
  STRUCTURED_LOGS_FLAG
} from '../structuredLogsFlag'

const StructuredLogModal = lazy(() => import('./StructuredLogModal'))

const LogModalSwitch = () => {
  const flags = useFeatureFlags({ flagNames: [STRUCTURED_LOGS_FLAG] as const })
  if (flags?.isLoading) return null
  return isStructuredLogsEnabled(flags?.data?.[STRUCTURED_LOGS_FLAG]) ? (
    <Suspense fallback={null}>
      <StructuredLogModal />
    </Suspense>
  ) : (
    <AddLogModal />
  )
}

export default LogModalSwitch
